export default {
  ENGLISH: 'en-US',
  SPANISH: 'es-US',
}
